import { Anchor } from '@mantine/core';
import { Link } from '@tanstack/react-router';

import { Id } from '@feature/utils';

export interface JournalLinkProps {
  journalId: Id;
  title: string;
}

export function JournalLink(props: JournalLinkProps) {
  const { journalId, title } = props;
  return (
    <Anchor
      fw="500"
      c="text"
      component={Link}
      to={`/journal/${journalId}`}
    >
      {title}
    </Anchor>
  );
}
